import { Modal } from "antd";
import type { ReactNode } from "react";

type Props = {
  children?: ReactNode;
  [key: string]: any;
};

// eslint-disable-next-line react/prop-types
export const DefaultModal: React.FC<Props> = ({ children, ...props }) => {
  return (
    <Modal destroyOnClose centered width="70%" maskClosable={false} keyboard={true} {...props}>
      {children}
    </Modal>
  );
};
